module.exports = __webpack_public_path__ + "static/media/4.b399a6aa.JPG";